<template>
    <v-container fluid>
        <v-row>
            <sarala-table
                :model="model"
                :createRoute="{ name: 'lead.create' }"
                :resourceName="$tc('resources.lead.name', 1)"
                ref="table"
            >
                <template #company="{ item }">
                    <template v-if="item.cnpj">
                        <span class="caption">
                            {{ $t('prospects.index.table.trade-name') }}:
                        </span>
                        <span class="body-2 font-weight-medium">{{
                            item.trade_name
                        }}</span>
                        <br />
                        <span class="caption"
                            >{{ $t('prospects.index.table.legal-name') }}:
                        </span>
                        <span class="body-2">{{ item.legal_name }}</span>
                        <br />
                    </template>

                    <template v-else>
                        <span class="caption">
                            {{ $t('prospects.index.table.name') }}:
                        </span>
                        <span class="body-2 font-weight-medium">{{
                            item.trade_name
                        }}</span>
                        <br />
                    </template>

                    <span class="caption">
                        {{ $t('prospects.index.table.document') }}:
                    </span>
                    <span class="body-2">{{ item.document }}</span>
                    <br />
                </template>

                <template #customer_trade_name="{ item }">
                    <template v-if="item.hasCustomer">
                        <router-link
                            :to="{
                                name: 'customer.show',
                                params: { id: item.customer.id },
                            }"
                            >{{ item.customer.trade_name }}</router-link
                        >
                    </template>
                    <template v-else>-</template>
                </template>

                <template #contacts="{ item }">
                    <span class="caption">
                        {{ $t('prospects.index.table.email') }}:
                    </span>
                    <span class="body-2">{{ item.email }}</span>
                    <br />
                    <span class="caption">
                        {{ $t('prospects.index.table.phone') }}:
                    </span>
                    <span class="body-2">{{ item.phone }}</span>
                    <br />
                </template>

                <template #action="{ item }">
                    <edit-btn
                        :to="{
                            name: 'lead.edit',
                            params: { id: item.id },
                        }"
                    />

                    <delete-btn
                        :disabled="item.deleted"
                        @click="deleteItem(item)"
                    />
                </template>
            </sarala-table>
        </v-row>
        <confirm-delete ref="confirmDelete" />
    </v-container>
</template>

<script>
import SaralaTable from '@/shared/components/SaralaTable'
import Lead from '@/models/Lead'
export default {
    components: {
        SaralaTable,
    },

    computed: {
        model() {
            return new Lead()
        },
    },

    methods: {
        async deleteItem(item) {
            let confirmed = await this.$refs.confirmDelete.confirm(
                item.trade_name,
            )
            if (!confirmed) return

            await item.delete()

            this.$refs.table.getItems()

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('resources.feedbacks.success.delete', {
                    resource: this.$tc('resources.lead.name'),
                }),
            )
        },
    },
}
</script>

<style></style>
